import React, {useState, useRef, useEffect} from 'react';
import {Carousel} from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import primera from './ImagenesCarouselInicio/banner_home.jpg'
import segunda from './ImagenesCarouselInicio/banner_home2.jpg'

/* import cloud from './ImagenesCarouselInicio/cloud.png';
import kalenday from './ImagenesCarouselInicio/kalenday.png';
import scrum from './ImagenesCarouselInicio/scrum.png'; */
import './styles.css';



export default function CarouselInicio(props){

    return(<>
    <div  className="contenedorCarousel">
    <div className="contenedorCarouselCentro">
    <Carousel autoPlay={true} infiniteLoop={true} axis showArrows={false} showStatus={false} showThumbs={false} dynamicHeight={false} stopOnHover={false} interval={5000} >
    <div>
      <img
        alt=""
        src={primera}
      />
    </div>
    
    <div>
      <img
        alt=""
        src={segunda}
      />
    </div>

    

{/*     <div>
      <img
        alt=""
        src={cloud}
      />
    </div>
    <div>
      <img src={kalenday}/>
    </div>
    <div>
      <img
        alt=""
        src={scrum}
      />
    </div> */}
    
        </Carousel>
        </div>
        </div></>)
}